<template>
  <f7-page no-navbar no-toolbar id="checkout-service-page">
    <div slot="fixed">
      <sh-checkout-bar selectedStep="service"></sh-checkout-bar>
    </div>

    <div class="spacer-top" />

    <div class="itemsWrapper">
      <div class="itemContainer" v-if="cartHasEaProducts">
        <div class="itemsHeader">
          <svg
            width="49"
            height="21"
            viewBox="0 0 49 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="itemsLogo"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M48.3283 7.98452V7.95953C48.3303 7.92982 48.326 7.90002 48.3157 7.87206V7.83457C48.3157 7.82208 48.3126 7.80958 48.3095 7.79709C48.3063 7.78459 48.3032 7.7721 48.3032 7.7596V7.73461L48.2781 7.63465H48.2655L46.5088 3.28627C46.3689 2.90571 46.114 2.57765 45.7792 2.34719C45.4444 2.11673 45.0461 1.99519 44.6392 1.99925H40.2975V0.999627C40.2975 0.734509 40.1918 0.48025 40.0035 0.292784C39.8153 0.105318 39.5599 0 39.2937 0H20.2207C19.6882 0 19.1775 0.210635 18.801 0.585567C18.4245 0.9605 18.213 1.46902 18.213 1.99925V3.77038L1.20987 3.77038C0.541676 3.77038 0 4.30978 0 4.97516C0 5.64055 0.541676 6.17995 1.20987 6.17995L18.213 6.17995V7.76123L3.70522 7.76123C3.03703 7.76123 2.49535 8.30063 2.49535 8.96601C2.49535 9.6314 3.03703 10.1708 3.70522 10.1708L18.213 10.1708V11.7521L7.56167 11.7521C6.89348 11.7521 6.3518 12.2915 6.3518 12.9569C6.3518 13.6222 6.89348 14.1616 7.56167 14.1616L18.213 14.1616V15.994C18.213 16.5243 18.4245 17.0328 18.801 17.4077C19.1775 17.7826 19.6882 17.9933 20.2207 17.9933H21.8519C22.073 18.8534 22.5754 19.6157 23.2797 20.1601C23.984 20.7045 24.8502 21 25.7418 21C26.6334 21 27.4996 20.7045 28.2039 20.1601C28.9082 19.6157 29.4105 18.8534 29.6317 17.9933H36.9096C37.1307 18.8534 37.633 19.6157 38.3373 20.1601C39.0416 20.7045 39.9079 21 40.7995 21C41.691 21 42.5573 20.7045 43.2616 20.1601C43.9659 19.6157 44.4682 18.8534 44.6893 17.9933H46.3206C46.8531 17.9933 47.3637 17.7826 47.7402 17.4077C48.1168 17.0328 48.3283 16.5243 48.3283 15.994V7.99701V7.98452ZM40.2975 3.99851H44.6392L45.8438 6.99739H40.2975V3.99851ZM25.7418 18.9929C25.3447 18.9929 24.9565 18.8757 24.6264 18.656C24.2962 18.4363 24.0389 18.1241 23.8869 17.7587C23.735 17.3934 23.6952 16.9914 23.7727 16.6036C23.8502 16.2158 24.0414 15.8596 24.3221 15.58C24.6029 15.3004 24.9607 15.11 25.3501 15.0328C25.7396 14.9557 26.1432 14.9953 26.5101 15.1466C26.877 15.2979 27.1905 15.5542 27.4111 15.8829C27.6317 16.2117 27.7495 16.5982 27.7495 16.9937C27.7495 17.5239 27.538 18.0324 27.1614 18.4073C26.7849 18.7823 26.2743 18.9929 25.7418 18.9929ZM40.7995 18.9929C40.4024 18.9929 40.0142 18.8757 39.684 18.656C39.3539 18.4363 39.0965 18.1241 38.9446 17.7587C38.7926 17.3934 38.7529 16.9914 38.8303 16.6036C38.9078 16.2158 39.099 15.8596 39.3798 15.58C39.6606 15.3004 40.0183 15.11 40.4078 15.0328C40.7972 14.9557 41.2009 14.9953 41.5678 15.1466C41.9346 15.2979 42.2482 15.5542 42.4688 15.8829C42.6894 16.2117 42.8071 16.5982 42.8071 16.9937C42.8071 17.5239 42.5956 18.0324 42.2191 18.4073C41.8426 18.7823 41.3319 18.9929 40.7995 18.9929Z"
            />
          </svg>
          <h1>Choice Doorstep&trade; Items</h1>
        </div>

        <h4>
          <span v-html="eaProductsInCartCount"></span>
          Items to be Shipped
        </h4>

        <f7-card class="serviceCards">
          <f7-card-header>
            Select SHIPPING Address
          </f7-card-header>

          <f7-card-content>
            <f7-list v-if="storedShippingAddresses">
              <div
                v-for="address in storedShippingAddresses"
                class="address-div-container"
              >
                <f7-list-item
                  radio
                  class="listItem"
                  name="selected-shipping-address"
                  v-if="
                    selectedShippingAddressId ==
                      address.stored_delivery_address_id
                  "
                  :checked="true"
                  :key="address.stored_delivery_address_id"
                  :value="address.stored_delivery_address_id"
                  @click="
                    setSelectedAddress(
                      'shipping',
                      address.stored_delivery_address_id
                    )
                  "
                >
                  <f7-card class="address-popout">
                    <f7-card-content class="text-center">
                      <div class="text-left address-popout-div">
                        <span
                          v-html="
                            formatShippingAddressId(selectedShippingAddressId, true)
                          "
                        ></span>
                      </div>
                    </f7-card-content>
                  </f7-card>
                </f7-list-item>

                <f7-list-item
                  class="listItem"
                  radio
                  name="selected-shipping-address"
                  v-if="
                    selectedShippingAddressId !=
                      address.stored_delivery_address_id
                  "
                  :title="formatAddress(address, false)"
                  :key="address.stored_delivery_address_id"
                  :value="address.stored_delivery_address_id"
                  @click="
                    setSelectedAddress(
                      'shipping',
                      address.stored_delivery_address_id
                    )
                  "
                ></f7-list-item>
              </div>
            </f7-list>
            <div
              title="+ Add New SHIPPING Address"
              data-popup=".popup-shipping"
              class="popup-open newAddressButton"
              @click="setSelectedAddress('shipping', 0)"
            >
              + Add New Shipping Address
            </div>
          </f7-card-content>
        </f7-card>

        <!-- POPUP - SHIPPING ADDRESS (Endless Aisle) -->
        <popup-new-shipping-address
          :states="states"
          :selectedLocation="selectedLocation"
          :selectedShippingAddressId="selectedShippingAddressId"
          @newAddressStored="newAddressStored($event)"
        ></popup-new-shipping-address>
      </div>
    <!-- MERGE ORDER -->
     <div class="block-title" style="margin-bottom:1em" v-if="mergeOrders.length>0">Add your shopping cart to an exiting order:</div>
      <div class="list media-list" v-if="mergeOrders.length>0">
        <ul>
          <li
          v-for="(order,i) in mergeOrders"
          :key="i">
            <label class="item-radio item-radio-icon-end item-content" style="margin-left:-10px">
              <input type="radio" name="order-selected" :value="order" v-model="orderSelected"/>
              <i class="icon icon-radio radio-icon"></i>
              <div class="item-inner">
                <div class="item-title-row">
                  <div class="item-title" style="opacity: 50%;">#{{(order.order_key).toUpperCase()}}</div>
                </div>
                <div class="item-text">
                  <span v-if="order.order_type == 'pickup'" style="font-size:12px">
                      Your <strong>pickup</strong> scheduled for <strong>{{formatDate(order.order_scheduled_delivery_time_end)+" @ "+formatTime(order.order_scheduled_delivery_time_end)}}</strong>
                    </span>
                    <span v-else  style="font-size:12px">
                      Your <strong>delivery</strong> scheduled between <strong>{{formatDate(order.order_scheduled_delivery_time_start)+" "+ formatTime(order.order_scheduled_delivery_time_start)}} 
                                          and {{formatTime(order.order_scheduled_delivery_time_end)}}</strong>
                    </span>
                </div>
              </div>
            </label>
          </li>
        </ul>
        <sh-checkout-button
        style="margin-bottom:1em"
              @onButtonClick="mergeOrder($event)"
              :disabledConditional="Object.keys(orderSelected).length !== 0"
            >
              Add to Existing Order 
          </sh-checkout-button>
        <p class="error" v-if="!mergeResponse.success">
          {{mergeResponse.message}}
        </p>
      </div>

      <div class="divider" v-if="mergeOrders.length>0"> <strong> Or Continue Below</strong></div>

      <div v-if="cartHasInStoreProducts">
        <div class="itemsHeader">
          <svg
            width="33"
            height="26"
            viewBox="0 0 33 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="itemsLogo"
          >
            <path
              d="M32.3125 9.28572H28.1358L20.756 0.490824C20.2642 -0.0952784 19.3965 -0.166546 18.8178 0.331632C18.2392 0.82981 18.1688 1.70888 18.6607 2.29498L24.5267 9.28572H8.47338L14.3394 2.29492C14.8312 1.70882 14.7608 0.829752 14.1822 0.331574C13.6036 -0.166604 12.7358 -0.0952783 12.244 0.490766L4.86412 9.28572H0.6875C0.307828 9.28572 0 9.59755 0 9.98215V11.375C0 11.7596 0.307828 12.0714 0.6875 12.0714H1.75696L3.3373 23.5975C3.52607 24.9747 4.68852 26 6.06111 26H26.9389C28.3115 26 29.4739 24.9747 29.6628 23.5975L31.243 12.0714H32.3125C32.6922 12.0714 33 11.7596 33 11.375V9.98215C33 9.59755 32.6922 9.28572 32.3125 9.28572ZM26.9389 23.2143H6.06111L4.53332 12.0714H28.4666L26.9389 23.2143ZM17.875 15.3214V19.9643C17.875 20.7336 17.2594 21.3571 16.5 21.3571C15.7406 21.3571 15.125 20.7336 15.125 19.9643V15.3214C15.125 14.5522 15.7406 13.9286 16.5 13.9286C17.2594 13.9286 17.875 14.5522 17.875 15.3214ZM24.2917 15.3214V19.9643C24.2917 20.7336 23.6761 21.3571 22.9167 21.3571C22.1573 21.3571 21.5417 20.7336 21.5417 19.9643V15.3214C21.5417 14.5522 22.1573 13.9286 22.9167 13.9286C23.6761 13.9286 24.2917 14.5522 24.2917 15.3214ZM11.4583 15.3214V19.9643C11.4583 20.7336 10.8427 21.3571 10.0833 21.3571C9.32393 21.3571 8.70833 20.7336 8.70833 19.9643V15.3214C8.70833 14.5522 9.32393 13.9286 10.0833 13.9286C10.8427 13.9286 11.4583 14.5522 11.4583 15.3214Z"
            />
          </svg>
          <h1>In-Store Items</h1>
        </div>

        <h4>
          <span v-html="inStoreProductsInCartCount"></span> Items for
          <span v-if="serviceType == 'pickup'">Pickup</span>
          <span v-else-if="serviceType == 'delivery'">Delivery</span>
          <span v-else>Pickup or Delivery</span>
        </h4>

        <!-- POPUP - PICKUP DETAILS -->
        <popup-pickup-info
          :serviceType="serviceType"
          :pickupInfo="pickupInfo"
          :phoneCountryCode="phoneCountryCode"
          @validatePickupInfo="validatePickupInfo"
        ></popup-pickup-info>

        <f7-card class="serviceCards">
          <f7-card-header>
            Select PICKUP or DELIVERY
          </f7-card-header>
          <f7-card-content>
            <f7-list>
              <div class="pickup-container">
                <f7-list-item
                  v-if="!serviceType || serviceType != 'pickup'"
                  radio
                  data-popup=".popup-pickup"
                  class="popup-open listItem"
                  name="selected-delivery-address"
                  :title="
                    'Pickup at ' + selectedLocation.physical_location_name
                  "
                  @click="
                    serviceType = 'pickup';
                    selectedDeliveryAddressId = null;
                    setOrderIsReady();
                  "
                >
                </f7-list-item>

                <f7-list-item
                  radio
                  v-if="serviceType && serviceType == 'pickup'"
                  name="selected-delivery-address"
                  class="listItem"
                  @click="
                    serviceType = 'pickup';
                    selectedDeliveryAddressId = null;
                    setOrderIsReady();
                  "
                >
                  <f7-card class="address-popout">
                    <f7-card-header class="card-header-popout"
                      >PICKUP AT:</f7-card-header
                    >
                    <f7-card-content class="text-center">
                      <div
                        class="text-left address-popout-div"
                        style="padding:10px 0 0px;"
                        v-if="serviceType == 'pickup'"
                      >
                        <div style="margin-top:-10px">
                          <div
                            style="font-size:16px;font-weight: bold;"
                            v-html="selectedLocation.physical_location_name"
                          ></div>
                          <div
                            v-html="
                              selectedLocation.physical_location_formatted
                            "
                          ></div>
                        </div>
                        <div style="margin-top:10px;">
                          <span class="text-bold">FOR:</span>
                        </div>
                        <div class="pickupInfoContainer">
                          <div
                            v-html="pickupInfoFormatted()"
                            v-if="pickupInfo"
                          ></div>
                          <span class="text-danger" v-else>
                            Please provide pickup info.
                          </span>
                          <a
                            data-popup=".popup-pickup"
                            @click="setOrderIsReady()"
                            class="popup-open editPickupInfoButton"
                          >
                            Edit
                          </a>
                        </div>
                      </div>
                    </f7-card-content>
                  </f7-card>
                </f7-list-item>
              </div>
            </f7-list>

            <f7-list v-if="storedDeliveryAddresses" style="padding-top:10px;">
              <div
                v-for="address in storedDeliveryAddresses"
                class="address-div-container"
              >
                <f7-list-item
                  class="listItem"
                  radio
                  name="selected-delivery-address"
                  v-if="
                    selectedDeliveryAddressId ==
                      address.stored_delivery_address_id
                  "
                  :checked="true"
                  :key="address.stored_delivery_address_id"
                  :value="address.stored_delivery_address_id"
                  @click="
                    setSelectedAddress(
                      'delivery',
                      address.stored_delivery_address_id
                    )
                  "
                >
                  <f7-card class="address-popout">
                    <f7-card-header class="card-header-popout">
                      DELIVER TO:
                    </f7-card-header>
                    <f7-card-content class="text-center">
                      <div class="text-left address-popout-div">
                        <span
                          v-html="
                            formatAddressId(selectedDeliveryAddressId, true)
                          "
                        ></span>
                      </div>
                    </f7-card-content>
                  </f7-card>
                </f7-list-item>

                <f7-list-item
                  radio
                  name="selected-delivery-address"
                  class="listItem"
                  v-if="
                    selectedDeliveryAddressId !=
                      address.stored_delivery_address_id
                  "
                  :title="'Deliver to ' + formatAddress(address, false)"
                  :key="address.stored_delivery_address_id"
                  :value="address.stored_delivery_address_id"
                  @click="
                    setSelectedAddress(
                      'delivery',
                      address.stored_delivery_address_id
                    )
                  "
                ></f7-list-item>
              </div>
            </f7-list>

            <div
              title="+ Add New DELIVERY Address"
              data-popup=".popup-delivery"
              class="popup-open"
              style="margin-top:25px;"
              @click="setSelectedAddress('delivery', 0)"
            >
              + Add New Delivery Address
            </div>
          </f7-card-content>
        </f7-card>

        <!-- POPUP - DELIVERY ADDRESS -->
        <popup-new-delivery-address
          :states="states"
          :selectedLocation="selectedLocation"
          :selectedDeliveryAddressId="selectedDeliveryAddressId"
          @newAddressStored="newAddressStored($event)"
        ></popup-new-delivery-address>

        <!-- PICKUP/DELIVERY REQUIRE DETAILS -->
        <f7-card
          class="errorRequireDetails"
          v-if="serviceType && serviceType == 'pickup' && !pickupInfo"
        >
          Please provide pickup info.
        </f7-card>

        <f7-card
          v-if="
            serviceType &&
              serviceType == 'delivery' &&
              !selectedDeliveryAddressId
          "
        >
          <span class="text-danger">Please provide a delivery address.</span>
        </f7-card>
      </div>

      <sh-checkout-button
        @onButtonClick="continueToNextStep($event)"
        :disabledConditional="orderIsReady"
      >
        Continue to Next Step
      </sh-checkout-button>
    </div>

    <div class="spacer-bottom" />
  
  </f7-page>
</template>

<script>
import $$ from "dom7";

import ShopHeroApi from "../../api/ShopHeroApi";
import ShCheckoutBar from "../../components/ShCheckoutBar.vue";
import ShAddressEditor from "../../components/ShAddressEditor.vue";

import Constants from "../../constants.js";
import PopupNewShippingAddress from "./popup-new-shipping-address.vue";
import PopupPickupInfo from "./popup-pickup-info.vue";
import PopupNewDeliveryAddress from "./popup-new-delivery-address.vue";
import ShCheckoutButton from "../../components/ShCheckoutButton.vue";

export default {
  data: function() {
    return {
      // STATES / PROVINCES
      states: Constants.state_map_usa,

      // ALL ADDRESSES (LOCAL DELIVERY & SHIPPING ADDRESSES)
      storedDeliveryAddresses: [],
      storedShippingAddresses: [],

      // PICKUP/DELIVERY - Local fulfillment (not shipments)
      serviceType: null,
      pickupInfo: null,
      selectedDeliveryAddressId: null,

      // SHIPPING - Endless Aisle (Sometimes abbreviated as EA)
      selectedShippingAddressId: null,

      // ORDER INFO TO BE SUBMITTED
      orderIsReady: false,
      orderInfo: {},

      //Only use to show in pickupInfoFormatted
      phoneCountryCode:"+1",
      phoneNumber:"",
      //Orders to merge
      mergeOrders:[],
      orderSelected:{},
      orderMergeLoading:false,
      //response from merge order request 
      mergeResponse:{}


      // I DON'T THINK I WANT TO USE ANY OF THIS
      // ,deliveryAddressValid: false
      // ,deliveryPickupError: null
      // ,deliveryNewAddressError: null
      // ,deliverySavedAddressError: null
      // ,buttonContent: "Continue to Schedule<span>&gt;</span>"
    };
  },

  components: {
    ShCheckoutBar,
    ShAddressEditor,
    PopupNewShippingAddress,
    PopupPickupInfo,
    PopupNewDeliveryAddress,
    ShCheckoutButton,
    
  },

  computed: {
     userIsAuthenticated: ({ $store }) => $store.getters.userIsAuthenticated,
    selectedLocation: ({ $store }) => $store.getters.selectedLocation,
    authenticatedUser: ({ $store }) => $store.getters.authenticatedUser,
    cartKey: ({ $store }) => $store.getters.cartKey,
    pickupAvailable: ({ $store }) =>
      $store.getters.cartConstraints.pickupEnabled,
    deliveryAvailable: ({ $store }) =>
      $store.getters.cartConstraints.deliveryEnabled,
    eaProductsInCartCount: ({ $store }) => $store.getters.eaProductsInCartCount,
    inStoreProductsInCartCount: ({ $store }) =>
      $store.getters.inStoreProductsInCartCount,
    cartHasEaProducts: ({ $store }) => $store.getters.cartHasEaProducts,
    cartHasInStoreProducts: ({ $store }) =>
      $store.getters.cartHasInStoreProducts,
  },

  watch: {
    //
  },

  methods: {
    setOrderIsReady: function() {
      if (this.cartHasEaProducts && !this.selectedShippingAddressId) {
        this.orderIsReady = false;
        return;
      }

      if (this.cartHasInStoreProducts) {
        if (
          (!this.serviceType || this.serviceType == "delivery") &&
          !this.selectedDeliveryAddressId
        ) {
          this.orderIsReady = false;
          return;
        }
        if (
          (!this.serviceType || this.serviceType == "pickup") &&
          !this.pickupInfo
        ) {
          this.orderIsReady = false;
          return;
        }
      }

      if (!this.cartHasEaProducts && !this.cartHasInStoreProducts) {
        this.orderIsReady = false;
        return;
      }

      this.orderIsReady = true;
      return;
    },

    continueToNextStep: function() {
      const orderInfo = this.getOrderInfo();
      const params = orderInfo.args;
      delete orderInfo.args;

      ShopHeroApi.deliveryPreschedule(
        this.selectedLocation.physical_location_id,
        this.cartKey,
        orderInfo.serviceType, // Used ONLY for LOCAL pickup/delivery items NOT shipped items (Choice Doorstep)
        params,
        (response) => {
          orderInfo.deliveryPrescheduleResponse = response;
          if (!response.success) {
            //ERROR
          }
          // SUCCESS - overwrite the order state and redirect
          this.$store.dispatch("checkoutMergeInfo", { orderInfo }).then(
            () => {
              this.$f7router.navigate("/checkout-schedule/");
            },
            (error) => {
              this.$f7router.navigate("/uhoh/");
            }
          );
        },
        (error) => {
          this.$f7.views.main.router.navigate("/uhoh/");
        }
      );
    },

    getOrderInfo: function() {
      // INITIALIZE THE VARIABLE
      let orderInfo = {
        // USE 'pickup' as DEFAULT if only SHIPPED items exist (No LOCAL PICKUP/DELVERY items in the order)
        serviceType: this.serviceType ? this.serviceType : "pickup",
        // PICKUP
        pickupFirstName: null,
        pickupLastName: null,
        pickupPhoneNumber: null,
        // DELIVERY
        storedDeliveryAddress: null,
        // SHIPPING
        storedShippingAddress: null,
        // API RESPONSE
        deliveryPrescheduleResponse: null, // used to store response from backend API

        // used in ShopHeroApi::deliveryPreschedule()
        // removed before submission to API (see: delete orderInfo.args)
        args: {
          pickup_first_name: null,
          pickup_last_name: null,
          pickup_phone_number: null,
          stored_delivery_address_id: null,
          stored_shipping_address_id: null,
        },
      };

      // FOR LOCAL ITEMS - ie. pickup/delivery Items
      switch (this.serviceType) {
        case "pickup":
          orderInfo.pickup_first_name = orderInfo.args.pickup_first_name = this.pickupFirstName;
          orderInfo.pickup_last_name = orderInfo.args.pickup_last_name = this.pickupLastName;
          orderInfo.pickup_phone_number = orderInfo.args.pickup_phone_number = this.pickupPhoneNumber;
          break;
        case "delivery":
          orderInfo.storedDeliveryAddress = this.getAddress(
            this.selectedDeliveryAddressId
          );
          orderInfo.args.stored_delivery_address_id = this.selectedDeliveryAddressId; // for params
          break;
      }

      // FPR SHIPPED ITEMS - ie. Choice Doorstep (Endless Aisle) Items
      if (this.cartHasEaProducts && this.selectedShippingAddressId) {
        orderInfo.storedShippingAddress = this.getShippingAddress(
          this.selectedShippingAddressId
        );
        orderInfo.args.stored_shipping_address_id = this.selectedShippingAddressId; // for params
      }

      return orderInfo;
    },

    cancel: function(event) {
      const addressType = event.addressType;
      this.setSelectedAddress(addressType, null);
    },

    setSelectedAddress: function(addressType, id) {
      let selector = "selected-" + addressType + "-address";
      switch (addressType.toLowerCase()) {
        case "delivery":
          this.selectedDeliveryAddressId = id;
          this.serviceType = id ? "delivery" : null;
          break;
        case "shipping":
          this.selectedShippingAddressId = id;
          break;
      }
      if (id) {
        this.checkRadio(selector, id);
      } else {
        this.uncheckRadios(selector);
      }
      this.setOrderIsReady();
    },

    checkRadio: function(selector, id) {
      let radios = document.getElementsByName(selector);
      for (var i = 0, length = radios.length; i <= length; i++) {
        if (typeof radios[i] !== 'undefined') {
          if (radios[i].value == id) {
            radios[i].checked = true; // only one radio can be checked, don't check the rest
            break;
          }
        }
      }
    },

    uncheckRadios: function(selector) {
      let radios = document.getElementsByName(selector);
      for (var i = 0, length = radios.length; i < length; i++) {
        radios[i].checked = false;
      }
    },

    // EVENT HANDLER
    newAddressStored: function(event) {
      this.setStoredDeliveryAddresses();
      this.setSelectedAddress(
        event.addressType,
        event.storedAddress.stored_delivery_address_id
      );
      this.$f7.popup.close();
    },

    setStoredDeliveryAddresses: function() {
      ShopHeroApi.getDeliveryAddresses((response) => {
        this.storedDeliveryAddresses = response.stored_delivery_addresses;
        this.storedShippingAddresses = response.stored_shipping_addresses;
      });
    },

    getAddress: function(id) {
      if (!this.storedDeliveryAddresses) return {};
      const self = this;
      for (let i = 0; i < self.storedDeliveryAddresses.length; i++) {
        if (self.storedDeliveryAddresses[i].stored_delivery_address_id == id) {
          return self.storedDeliveryAddresses[i];
        }
      }
      return {};
    },
    getShippingAddress: function(id) {
      if (!this.storedShippingAddresses) return {};
      const self = this;
      for (let i = 0; i < self.storedShippingAddresses.length; i++) {
        if (self.storedShippingAddresses[i].stored_delivery_address_id == id) {
          return self.storedShippingAddresses[i];
        }
      }
      return {};
    },

    formatAddress: function(address, multiline) {
      let name = [];
      if (address.address_first_name) name.push(address.address_first_name);
      if (address.address_last_name) name.push(address.address_last_name);

      let location = [];
      if (address.address_address1) location.push(address.address_address1);
      if (address.address_address2) location.push(address.address_address2);
      if (address.address_city) location.push(address.address_city);
      if (address.address_state) location.push(address.address_state);

      const company = address.address_company ? address.address_company : "";
      const zip = address.address_zip ? address.address_zip : "";

      return (
        (company
          ? company +
            (multiline ? "<br/>" + (name.length ? "Attn: " : ", ") : "")
          : "") +
        name.join(" ") +
        (multiline ? "<br/>" : " - ") +
        location.join(", ") +
        (zip ? " " + zip : "")
      );
    },

    formatAddressId: function(id, multiline) {
      const address = this.getAddress(id);
      return address ? this.formatAddress(address, multiline) : "";
    },
    formatShippingAddressId: function(id, multiline) {
      const address = this.getShippingAddress(id);
      return address ? this.formatAddress(address, multiline) : "";
    },
    validatePickupInfo: function() {
      this.setOrderIsReady();
      const firstName = $$("#pickup-info-input-first-name").val();
      const lastName = $$("#pickup-info-input-last-name").val();
      const phone = $$("#pickup-info-input-phone-number").val();
      let countryCode=$$("#pickup-info-input-country-code").val();
      this.phoneCountryCode=countryCode;
      this.phoneNumber=phone;
      let validCountryCode =countryCode.match(/\+[0-9]{1,4}$/);
      var validPhone=false;
      //validation is applied according to the country code
      if(countryCode=="+1"){
        validPhone= phone.match(/^(\d{3})(\d{3})(\d{4})$/);
      }else{
        validPhone= phone.match(/^[0-9]{6,15}$/);
      }
      
      if (firstName.length > 0 && lastName.length > 0 && validPhone && validCountryCode) {
        this.pickupInfo = {
          firstName: firstName,
          lastName: lastName,
          phone: countryCode+""+""+phone,
        };
        this.setOrderIsReady();
        return true;
      }
      this.pickupInfo = null;
      return false;
    },

    pickupInfoFormatted: function() {
      if (!this.pickupInfo) return "Not working.";
      
      return (
        this.pickupInfo.firstName +
        " " +
        this.pickupInfo.lastName + " "+
        this.formatPhone()
      );
    },
    formatPhone: function() {
      //if it is a usa number, the corresponding format is applied
      if(this.phoneCountryCode=="+1"){
        var s2 = ("" + this.phoneNumber).replace(/\D/g, "");
        //3334443333=success
        //m=[number,area,direccional1,direccional2]
        var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
        return !m ? null : "+1 (" + m[1] + ") " + m[2] + "-" + m[3];
      }
      else{
        return this.phoneCountryCode+" "+this.phoneNumber;
      }
    },

    logAnalyticsInitiatedCheckout() {
      if (typeof facebookConnectPlugin !== "undefined") {
        facebookConnectPlugin.logEvent(
          "Initiated Checkout",
          {},
          0,
          function() {
            // log success
          },
          function() {
            // log error
          }
        );
      }
    },
    //do merge to the order then navigate to order and clear history and clear the cart
    mergeOrder(){
      ShopHeroApi.doCheckoutOrderMerge(this.orderSelected.order_key,{physicalLocationId:this.selectedLocation.physical_location_id},(response)=>{
        if(response.success){
          this.$f7router.navigate(`/orders/${response.data.order_key}/${response.data.items_added_count}`);
          this.$store.dispatch("populateCart", {physicalLocationId: this.selectedLocation.physical_location_id,});
        }else{
          //if has an error then 
          this.mergeResponse=response;
        }
      });
    },
    formatDate(date){
      return new Date(date).toLocaleDateString('en-us', {  year:"numeric", month:"short", day:"numeric"}) ;
    },
    formatTime(date){
      return new Date(date).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit',hour12:true});
    }
  },

  mounted() {
    $$("#button-pickup-continue-to-schedule").html(this.buttonContent);

    $$("*").attr("tabindex", "-1");

    $$("#pickup-info-input-first-name").val(this.authenticatedUser.firstName);
    $$("#pickup-info-input-last-name").val(this.authenticatedUser.lastName);
    $$("#pickup-info-input-country-code").val("+1");
    // $$('#pickup-info-input-phone-number').val()

    this.setStoredDeliveryAddresses();
    (this.deliveryState = this.selectedLocation.physical_location_state),
      this.logAnalyticsInitiatedCheckout();

    //get all open orders and if has pending orders
    if(this.userIsAuthenticated) {
      ShopHeroApi.getMergeOrders(this.selectedLocation.physical_location_id,(response) => {
          this.mergeOrders = response.open_orders;
      })
    }
  },
};
</script>

<style lang="scss" scoped="false">
.spacer-top {
  margin-top: 0px;
}

.spacer-bottom {
  height: calc(270px + var(--sab));
}

#checkout-service-page {
  background: white;
}

.itemsWrapper {
  padding: 28px 20px;
}

.itemContainer {
  margin-bottom: 32px;
}

.itemsHeader {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.itemsLogo {
  path {
    fill: $storePrimaryColor;
  }
}

.serviceCards {
  margin: 8px 0px !important;
}

.card-header {
  color: $storePrimaryColor;
  font-weight: $bold;
}

.list {
  font-size: 14px !important;
}

.listItem {
  border-bottom: solid 0.5px #e5e6e6;
}

input {
  color: $storePrimaryColor !important;
}

.disabled {
  background: #ccc;
  color: #fff;
  cursor: not-allowed;
}

.address-div-container {
  border-bottom: 1px solid #eee;
  margin: 0px 10px;
  padding-top: 5px;
}

.pickup-container {
  margin: 0px 10px;
  padding-top: 5px;
}

.address-popout-div {
  font-size: 14px;
}

.address-popout {
  margin: 0px -15px !important;
  width: 100%;
  box-shadow: none;
  border: 1px dotted $storePrimaryColor;
  border-radius: 5px;
  // Necessary evil, because of intrusive global styles
  .card-content-padding {
    padding: 5px !important;
  }
}

.card-header-popout {
  font-size: 1rem !important;
  color: initial;
}

li {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.text-danger {
  color: #d02a2e;
}

.errorRequireDetails {
  margin: 32px 0px !important;
  background: #d02a2e;
  color: white;
  font-weight: 800;
}

.pickupInfoContainer {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
}

.editPickupInfoButton {
  padding: 4px 8px;
  background: $storePrimaryColor;
  color: white;
  border-radius: 4px;
}

.newAddressButton {
  margin-top: 25px;
}
.merge-order-container{
  align-content: center;
  margin: 2em;
}
.error{
  color: red;
  text-align: center;
  font-size: 1.0em;
  margin-bottom: 1em;
}

.item-radio {
  span {
    width: 100%;
  }
}
.divider {
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 1.4em;
  color: rgb(194, 187, 187);
  margin-top: 3em;
  margin-bottom: 2em;
}

/* To show the lines on right 
and left sides of the text */
.divider::after,
.divider::before {
  content: "";
  border: 1px solid rgb(194, 187, 187);
  flex: 1;
}

/* Space on left and right sides of text */
.divider:not(:empty)::before {
  margin-right: 0.25em;
}

.divider:not(:empty)::after {
  margin-left: 0.25em;
}
.radio-icon{
  size: 100px;
  color: $storePrimaryColor;

}
</style>
